import { absoluteTime, relativeTime } from "./relative_time";

/** "1,260 min" / "−30 min" */
export const formatMinutes = (minutes: number): string =>
	`${minutes < 0 ? "−" : ""}${Math.abs(minutes).toLocaleString()} min`;

/** "5 min ago", "yesterday, 14:05", "12 Oct" — the exact moment is `absoluteDateTime`, for a tooltip. */
export const formatDateTime = (ms: number | null | undefined): string => (ms == null ? "—" : relativeTime(ms));

export const absoluteDateTime = (ms: number | null | undefined): string | undefined =>
	ms == null ? undefined : absoluteTime(ms);

export const formatDate = (ms: number | null | undefined): string => (ms == null ? "—" : relativeTime(ms));
